<template>
  <section>
    <!-- 项目研究及专利 -->
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <b-container fluid>
      <b-row class="justify-content-center newCenter">
        <b-col cols="12" sm="10" md="9" xl="8">
          <div class="project">
            <b-tabs content-class="mt-3" @input="inputTab" class="projectTabs">
              <b-tab
                v-for="(item, index) in projectData"
                :key="index"
                :title="item.title"
                :active="index === 0 ? true : false"
              >
                <p class="context" style="text-align: justify;">
                  {{ item.text }}
                </p>
                <div style="display: flex" class="upAndDown">
                  <p class="mask" :class="ClickCount > 0 ? 'maskLeft' : ''">
                    <span
                      class="btn prev"
                      @click="innerMove('left')"
                      :style="ClickCount > 0 ? '' : 'pointer-events: none'"
                    ></span>
                    <!-- <el-button class="prev" type="text" disabled
                      >上一页</el-button
                    > -->
                  </p>
                  <div class="scroll" ref="scroll">
                    <!-- 如果数据大于6个,纵向排列 ;目前还不是,需要调整,静态页面先这样-->
                    <div
                      ref="innerScroll"
                      id="More"
                      :style="moveMes"
                      style="transition: all 1s"
                      v-if="item.children.length > 6"
                    >
                      <div
                        ref="itemPro"
                        class="itemProject"
                        :class="tabIndex == 1 ? 'itemProJectSec' : ''"
                        v-for="item1 in item.children"
                        :key="item1.id"
                      >
                        <h3>{{ item1.title }}</h3>
                        <p>{{ item1.system || item1.text }}</p>
                        <p>{{ item1.department || item1.time }}</p>
                      </div>
                    </div>
                    <!-- 如果数据小于等于6个,横向排列-->
                    <div
                      ref="innerScroll"
                      id="innerScroll"
                      :style="moveMes"
                      style="transition: all 1s"
                      v-else
                    >
                      <div
                        ref="itemPro"
                        class="itemProject"
                        :class="tabIndex == 1 ? 'itemProJectSec' : ''"
                        v-for="item1 in item.children"
                        :key="item1.id"
                      >
                        <h3>{{ item1.title }}</h3>
                        <p>{{ item1.system || item1.text }}</p>
                        <p>{{ item1.department || item1.time }}</p>
                      </div>
                    </div>
                  </div>
                  <p class="mask maskRight">
                    <!-- :class="item.children.length >= 3 ? 'maskRight' : ''" -->
                    <span
                      class="btn next"
                      @click="innerMove('right')"
                      :style="notClick ? 'pointer-events: none' : ''"
                    ></span>
                  </p>
                </div>
                <p id="tips">{{ item.tips }}</p>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      subBannerInfo: {
        img: require("@/assets/images/e-gov_banner.png"),
        title: "软著与专利",
        subTitle: "Software copyrights and patents",
      },
      rightBtn: false,
      moveMes: "",
      notClick: false,
      ClickCount: 0,
      tabIndex: 0,
      projectData: [
        {
          id: "1",
          title: "软著",
          text: "信息中心高度重视知识产权的积累和保护，积极申请软著，范围涵盖了已建设的飞行标准监督管理系统、民航行政审批服务平台等项目以及自主研发的USP统一服务平台、“航数聚”运输航空市场数据综合展现平台等产品，截至2021年底，已获得软著72项。",
          tips: "",
          children: [
            {
              id: "8",
              title:
                "民航行业监管执法信息系统软件[简称：监管执法信息系统软件]V1.0",
              system: "软著登字第5424285号",
            },
            {
              id: "9",
              title: "维修人员电子执照系统软件[简称：维修电子执照系统软件]V1.0",
              system: "软著登字第5148288号",
            },
            {
              id: "10",
              title: "电子体检合格证系统软件[简称：体检合格证系统软件]V1.0",
              system: "软著登字第5148294号",
            },
            {
              id: "11",
              title: "云执照系统软件V1.0",
              system: "软著登字第5148232号",
            },
            {
              id: "12",
              title:
                "民航维修培训机构管理系统软件[简称：维修培训机构管理系统软件]1.0",
              system: "软著登字第5148270号",
            },
            {
              id: "13",
              title: "委任代表和检查员管理系统软件V1.0",
              system: "软著登字第5148276号",
            },
            {
              id: "14",
              title: "电子规章管理系统软件[简称：电子规章系统软件]V1.0",
              system: "软著登字第5148282号",
            },
            {
              id: "15",
              title: "航空器评审系统软件V1.0",
              system: "软著登字第5148435号",
            },
            {
              id: "16",
              title: "121部审定监察系统软件V1.0",
              system: "软著登字第5148226号",
            },
            {
              id: "17",
              title: "安全绩效分析系统软件V1.0",
              system: "软著登字第5148214号",
            },
            {
              id: "18",
              title: "驾驶员学校监管系统软件V1.0",
              system: "软著登字第5148220号",
            },
            {
              id: "19",
              title:
                "飞行签派员训练机构管理系统软件[简称：签派员训练机构管理系统软件]V1.0",
              system: "软著登字第5145876号",
            },
            {
              id: "20",
              title: "飞行签派员资质管理系统软件[简称：签派员管理系统软件]V1.0",
              system: "软著登字第5145882号",
            },
            {
              id: "21",
              title: "飞行模拟训练设备管理系统软件V1.0",
              system: "软著登字第5145903号",
            },
            {
              id: "22",
              title: "民航维修人员信息平台软件V1.0",
              system: "软著登字第5145957号",
            },
            {
              id: "23",
              title: "云执照桌面系统软件[简称：云桌面系统软件]V1.0",
              system: "软著登字第5145962号",
            },
            {
              id: "24",
              title: "飞行训练中心监管系统软件V1.0",
              system: "软著登字第5145998号",
            },
            {
              id: "25",
              title: "129外航审定监察应用软件V1.0",
              system: "软著登字第5146004号",
            },
            {
              id: "26",
              title: "体检合格证管理系统软件V1.0",
              system: "软著登字第5146138号",
            },
            {
              id: "27",
              title:
                "飞行标准监察员资质管理系统软件[简称：监察员管理系统软件]V1.0",
              system: "软著登字第5146271号",
            },
            {
              id: "28",
              title: "在线考试系统软件[简称：考试系统软件]V1.0",
              system: "软著登字第5146276号",
            },
            {
              id: "29",
              title: "使用困难报告系统软件V1.0",
              system: "软著登字第5146282号",
            },
            {
              id: "30",
              title: "飞行程序和最低运行标准系统软件V1.0",
              system: "软著登字第5146317号",
            },
            {
              id: "31",
              title:
                "145维修单位审定监管系统软件[简称：维修单位审定监管系统软件]V1.0",
              system: "软著登字第5146322号",
            },
            {
              id: "32",
              title: "通用航空运营人监管系统软件[简称：通航监管系统软件]V1.0",
              system: "软著登字第5146327号",
            },
            {
              id: "33",
              title:
                "135小型航空器商业运输运营人监管系统软件[简称：135小型监管系统软件]V1.0",
              system: "软著登字第5146342号",
            },
            {
              id: "34",
              title:
                "航空人员体检医师及体检机构资质管理系统软件[简称：体检医师及体检机构管理系统软件]V1.0",
              system: "软著登字第5146337号",
            },
            {
              id: "35",
              title: "民用航空运输价格管理信息系统V1.0",
              system: "软著登字第1325551号",
            },
            {
              id: "36",
              title: "民用航空航油价格管理信息系统V1.0",
              system: "软著登字第1325596号",
            },
            {
              id: "37",
              title: "民用航空价格指数信息系统V1.0",
              system: "软著登字第1325601号",
            },
            {
              id: "38",
              title: "民航投资建设项目管理信息系统V1.0",
              system: "软著登字第3858434号",
            },
            {
              id: "39",
              title:
                "适航业务模型及标准化库平台[简称：适航业务五大数据库平台]V1.0",
              system: "软著登字第7200842号",
            },
            {
              id: "40",
              title: "适航审定运行管理行政办公系统[简称：AMOS行政办公系统]V1.0",
              system: "软著登字第5412666号",
            },
            {
              id: "41",
              title: "“航数聚”运输航空市场数据综合展现平台",
              system: "软著登字第8259491号",
            },
            {
              id: "42",
              title: "企业法定自查系统V1.0",
              system: "软著登字第7686319号",
            },
            {
              id: "43",
              title: "USP统一服务平台[简称：USP]V1.0",
              system: "软著登字第8718079号",
            },
            {
              id: "44",
              title: "航空公司手册管理系统[简称：航司手册系统]V1.0",
              system: "软著登字第8718078号",
            },
            // 这是添加的几项
            {
              id: "45",
              title: "民用机场专用设备信息管理系统v1.0",
              system: "",
            },
            {
              id: "46",
              title: "民航专业工程建设项目招标投标管理系统",
              system: "",
            },
            {
              id: "47",
              title: "重点工程综合管控信息系统V1.0",
              system: "",
            },
            {
              id: "48",
              title: "重点工程综合管控信息系统安卓版V1.0",
              system: "",
            },
            {
              id: "49",
              title: "重点工程综合管控信息系统IOS版V1.0",
              system: "",
            },
            {
              id: "50",
              title: "民航行政审批服务平台服务门户系统V1.0",
              system: "",
            },
            {
              id: "51",
              title: "民航行政审批服务平台移动APPV1.0",
              system: "",
            },
            {
              id: "52",
              title: "民航行政审批服务平台受理办理系统V1.0",
              system: "",
            },
            {
              id: "53",
              title: "民航行政审批服务平台“好差评”系统V1.0",
              system: "",
            },
            {
              id: "54",
              title: "民航档案查阅管理系统",
              system: "",
            },
            {
              id: "55",
              title: "民航局固定资产管理系统",
              system: "",
            },
            {
              id: "56",
              title: "民航行政审批服务平台V1.0",
              system: "",
            },
            {
              id: "57",
              title: "民航数据资源全文搜索引擎系统",
              system: "",
            },
            {
              id: "58",
              title: "民航数据共享交换平台",
              system: "",
            },
            {
              id: "59",
              title: "民航综合统计信息系统数据分析子系统",
              system: "",
            },
            {
              id: "60",
              title: "“航数聚”运输航空市场数据分析系统V1.0",
              system: "",
            },
            {
              id: "61",
              title: "民航电子证照系统V1.0",
              system: "",
            },
            {
              id: "62",
              title: "民航电子证照系统证照卡包移动软件V1.0",
              system: "",
            },
            {
              id: "63",
              title: "民航智能法规库系统",
              system: "",
            },
            {
              id: "64",
              title: "中国民用航空局信息中心短信服务平台V1.0",
              system: "",
            },
            {
              id: "65",
              title: "民用无人驾驶航空器综合管理平台移动应用系统",
              system: "",
            },
            {
              id: "66",
              title: "民航局网络安全态势感知和预警平台",
              system: "",
            },
            {
              id: "67",
              title: "电子政务专网一体化运维管理系统V1.0",
              system: "",
            },
            {
              id: "68",
              title: "民航局信访工作系统",
              system: "",
            },
            {
              id: "69",
              title: "民航局机关公务员考核系统",
              system: "",
            },
            {
              id: "70",
              title: "因公临时出国（境）管理系统",
              system: "",
            },
            {
              id: "71",
              title: "民航电子政务综合办公系统",
              system: "",
            },
            {
              id: "72",
              title: "操控员电子证照管理系统",
              system: "",
            },
          ],
        },
        {
          id: "2",
          title: "专利",
          text: "信息中心高度重视知识产权管理工作，依托项目建设，同时注重加强总结和凝练创新点，积极开展专利申请工作，目前已在行李全流程跟踪、适航审定等领域取得发明专利2项，实用新型专利1项，正在申请中的发明专利4项。",
          tips: "备注:正在申请中的发明专利4项(适航领域)",
          children: [
            {
              id: "1",
              title: "发明专利",
              text: "用于旅客行李的检测方法和装置",
              time: "2018年",
            },
            {
              id: "2",
              title: "发明专利",
              text: "一种RFID适航证书销毁记录系统及方法",
              time: "2021年",
            },
            {
              id: "3",
              title: "实用新型专利",
              text: "一种RFID适航证书销毁记录装置",
              time: "2020年",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      let screenWidth = window.innerWidth;
      this.setReSize(screenWidth);
    };
    this.setReSize(window.innerWidth);
  },
  methods: {
    // changeDirection(){
    //   if(this.projectData)
    // },
    inputTab(tabIndex) {
      this.ClickCount = 0
      this.notClick = false
      this.moveMes = "";
      this.tabIndex = tabIndex;
    },
    setReSize(screenWidth) {
      if (screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/e-gov_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/e-m.png");

      }
    },
    innerMove(direction) {
      // console.log("点击");
      // debugger;
      let item = this.$refs.itemPro;
      let offsetWidth1 = 0,
        marginRight = 0;

      // 遍历每一项item,如果有width,就获取到此宽度值
      for (let i = 0; i < item.length; i++) {
        if (item[i].offsetWidth > 0) {
          offsetWidth1 = item[i].offsetWidth;
          marginRight = window.getComputedStyle(item[i], null).marginRight;
          break;
        }
      }

      // 取item项的marginRight值
      let right = Number(marginRight.split("px")[0]); //每一项的marginRight的值
      let scrollWidth = this.$refs.innerScroll[this.tabIndex].scrollWidth; //滚动区域的总体宽度
      let scroll = this.$refs.scroll[this.tabIndex].offsetWidth; //滚动区域外层的宽度
      // console.log(scrollWidth, scroll);
      // 点击了向左
      let blockWidth = offsetWidth1 + right;
      if (direction === "left") {
        this.ClickCount--;
        this.notClick = false;
        if (this.ClickCount < 0) {
          this.ClickCount = 0;
        }
        let ScrLeft = blockWidth * this.ClickCount; //blockWidth * this.ClickCount
        this.moveMes = `margin-left: -${ScrLeft}px;`;
      } else if (direction === "right") {
        this.ClickCount++;
        let ScrRight = blockWidth * this.ClickCount;
        if (scrollWidth - blockWidth * this.ClickCount < scroll) {
          ScrRight = scrollWidth - scroll;
          this.notClick = true;
          // if (!this.rightBtn) {
          //   this.rightBtn = true;
          //   this.ClickCount++;
          // }
          // this.ClickCount--;
        }
        this.moveMes = `margin-left: -${ScrRight}px;`;
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/project-search.css";
.scroll #More {
  flex-direction: column !important;
  /* width: 1260px; */
  height: 640px;
}
.scroll #More .itemProject {
  width: 380px;
  flex: 0 0 180px;
}
</style>
<style lang="less">
@media (max-width: 575px) {
  .project {
    padding-top: 60px;
    padding-bottom: 50px;
  }
  .projectTabs .nav-tabs .nav-item a.nav-link {
    padding: 0 40px;
    font-size: 15px;
  }
  .tab-content.mt-3 {
    // padding: 0 50px !important;
    .tab-pane.active {
      padding: 0 40px;
    }
    .context {
      font-size: 14px;
    }
    .upAndDown {
      margin-top: 0px;
      .btn {
        transform: scale(0.5);
        // top: calc(51% + 120px);
        top: calc(57%);
      }
      .prev {
        left: 50px;
      }
      .next {
        right: 50px;
      }
      .scroll {
        > div {
          width: 720px;
          .itemProject {
            flex: 0 0 220px;
            /* height: 120px; */
            margin-right: 20px;
            margin-bottom: 20px;
            h3 {
              font-size: 14px;
              margin-top: 0px;
            }
            p {
              font-size: 14px;
            }
          }
          .itemProject:nth-of-type(3n + 3) {
            margin-right: 0px;
          }
        }
        #More {
          flex-direction: column !important;
          height: 480px;
          width: 720px;
          .itemProject {
            width: 220px;
            flex: 0 0 80px;
          }
        }
      }
    }
    #tips {
      font-size: 14px;
    }
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .project {
    padding-bottom: 50px;
    padding-top: 50px;
  }
  .nav-tabs .nav-item a {
    padding: 0 40px;
    font-size: 16px;
  }
  .tab-content {
    // padding: 0 50px;
    .context {
      font-size: 14px;
    }
    .upAndDown {
      margin-top: 30px;
      .btn {
        transform: scale(0.7);
        // top: calc(51% + 120px);
        top: calc(57%);
      }
      .scroll {
        > div {
          width: 930px;
          .itemProject {
            flex: 0 0 280px;
            height: 140px;
            margin-right: 30px;
            margin-bottom: 30px;
            h3 {
              font-size: 16px;
            }
            p {
              font-size: 14px;
            }
          }
          .itemProject:nth-of-type(3n + 3) {
            margin-right: 0px;
          }
        }
        #More {
          flex-direction: column !important;
          height: 500px;
          width: 900px;
          .itemProject {
            width: 280px;
            flex: 0 0 140px;
          }
        }
      }
    }
    #tips {
      font-size: 14px;
    }
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .project {
    padding-bottom: 100px;
  }
  .nav-tabs .nav-item a {
    padding: 0 40px;
    font-size: 19px;
  }
  .tab-content {
    // padding: 0 50px;
    .context {
      font-size: 16px;
    }
    .upAndDown {
      margin-top: 30px;
      .btn {
        transform: scale(0.7);
        // top: calc(51% + 120px);
        top: calc(57%);
      }
      .scroll {
        > div {
          width: 1140px;
          .itemProject {
            flex: 0 0 340px;
            height: 160px;
            margin-right: 40px;
            margin-bottom: 30px;
            h3 {
              font-size: 18px;
            }
            p {
              font-size: 16px;
            }
          }
          .itemProject:nth-of-type(3n + 3) {
            margin-right: 0px;
          }
        }
        #More {
          flex-direction: column !important;
          height: 600px;
          width: 1140px;
          .itemProject {
            width: 340px;
            flex: 0 0 160px;
          }
        }
      }
    }
    #tips {
      font-size: 16px;
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .project {
    padding-bottom: 100px;
  }
  .projectTabs .nav-tabs .nav-item a {
    padding: 0 40px;
    font-size: 20px;
  }
  .tab-content {
    // padding: 0 50px;
    .context {
      font-size: 18px;
    }
    .upAndDown {
      margin-top: 30px;
      .btn {
        transform: scale(0.7);
        // top: calc(51% + 120px);
        top: calc(57%);
      }
      .scroll {
        > div {
          // width: 1260px;
          .itemProject {
            flex: 0 0 380px;
            height: 180px;
            margin-right: 40px;
            margin-bottom: 30px;
            h3 {
              font-size: 20px;
            }
            p {
              font-size: 18px;
            }
          }
          .itemProject:nth-of-type(3n + 3) {
            margin-right: 0px;
          }
        }
        #More {
          flex-direction: column !important;
          height: 630px;
          // width: 1260px;
          .itemProject {
            width: 380px;
            flex: 0 0 180px;
          }
        }
      }
    }
    #tips {
      font-size: 18px;
    }
  }
}
@media (min-width: 1200px) {
  .project {
    padding-bottom: 100px;
    padding-top: 90px;
  }
  .projectTabs .nav-tabs .nav-item a {
    padding: 0 50px;
    // font-size: 18px;
  }
  .tab-content {
    // padding: 0 50px;
    .context {
      font-size: 18px;
    }
    .upAndDown {
      margin-top: 30px;
      .btn {
        transform: scale(0.7);
        // top: calc(51% + 120px);
        top: calc(57%);
      }
      .scroll {
        > div {
          // width: 1260px;
          .itemProject {
            flex: 0 0 380px;
            height: 180px;
            margin-right: 40px;
            margin-bottom: 30px;
            h3 {
              font-size: 20px;
            }
            p {
              font-size: 18px;
            }
          }
          .itemProject:nth-of-type(3n + 3) {
            margin-right: 0px;
          }
        }
      }
    }
    #tips {
      font-size: 18px;
    }
  }
}
</style>
